import React, { useState } from 'react';

import { withQueryparams } from '@/main/components/core/queryParams/queryparams';
import ContainerScreen from '@/main/components/shared/containerScreen/containerLayout';
import { getTranslateByKey } from '@/main/services/utils';
import FiltersSearchValuator from './filtersValuatorScreen/filtersValuatorScreen';
import GridSearchValuator from './gridValuatorScreen/gridValuatorScreen';
import { ValuatorSearchGridResponse } from '@/main/models/response';
import { ValuatorFilterRequest } from '@/main/models/request';
import { PaginationEnum } from '@/main/services/enum/PaginationEnum';

function SearchValuatorScreen() {
  const titlePage = `${getTranslateByKey(
    'information.registration'
  )} > ${getTranslateByKey('information.searchValuator')}`;

  const [dataGrid, setDataGrid] = useState<ValuatorSearchGridResponse[]>([]);
  const [formFilters, setFormFilters] = useState<ValuatorFilterRequest | null>(
    null
  );

  function onResetSearch() {
    setDataGrid([]);
    setFormFilters(null);
  }

  async function getDataSearchValuator(
    filters: ValuatorFilterRequest | Partial<ValuatorFilterRequest> = {},
    isResetSearch: boolean = true
  ) {
    const request: ValuatorFilterRequest = {
      ...(isResetSearch ? {} : formFilters),
      ...(filters as ValuatorFilterRequest),
      pageIndex: PaginationEnum.PageIndexIntial,
      pageSize: PaginationEnum.PageSize30
    };

    onResetSearch();
    setFormFilters(request);
  }

  return (
    <ContainerScreen title={titlePage}>
      <FiltersSearchValuator
        onResetSearch={onResetSearch}
        getDataSearchValuator={getDataSearchValuator}
      />
      <GridSearchValuator
        dataGrid={dataGrid}
        formFilters={formFilters}
        setDataGrid={setDataGrid}
      />
    </ContainerScreen>
  );
}

export default withQueryparams(SearchValuatorScreen);
